import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { robotusecases } from './robotusecases';


function UseCases() {
    const navigate = useNavigate();

    return (
        <>
            <div id="useCase">
                <h2 className='text-center '>Use Case</h2>
                <hr />
                <div className="pt-5">
                    {Array.isArray(robotusecases) && robotusecases.map((item, index) => {
                        return <div key={index} className='mb-3'>
                                <div className='row justify-content-center align-items-center'>
                                    <div className={index % 2 === 0 ? 'p-5 text-center col-md-5' : 'p-5 text-center col-md-5 order-md-2'}>
                                        <img height={500} width={500} className='img-fluid' src={item.image} alt={item.title} />
                                    </div>
                                    <div style={{ fontSize: '1rem' }} className='p-5 col-md-5' >
                                        <h3 className=' blueText'>{item.title}</h3>
                                        <p>{item.details}</p>
                                        <button style={{
                                            backgroundColor: '#081b72',
                                            color: 'white',
                                        }} className="btn">Explore</button>
                                    </div>
                                </div>
                            </div>

                    })}
                </div>
            </div>
        </>
    )
}
export default UseCases
